import { Share2 } from "lucide-react";
import { buildInviteText, shareInvite } from "@/lib/share";
import { cn } from "@/lib/utils";

type Props = {
  variant?: "cta" | "icon" | "ghost";
  groupName?: string;
  code?: string | null;
  label?: string;
  className?: string;
};

export function InviteButton({ variant = "cta", groupName, code, label, className }: Props) {
  const onClick = () => {
    const text = buildInviteText({ groupName, code });
    shareInvite(text, groupName ? `Gruppe „${groupName}"` : "Englputzeder Tippspiel");
  };

  if (variant === "icon") {
    return (
      <button
        onClick={onClick}
        title="Freunde einladen"
        aria-label="Freunde einladen"
        className={cn(
          "inline-flex items-center justify-center rounded-pill bg-[#25D366] text-white h-9 w-9 tap shadow-card hover:opacity-90 transition",
          className,
        )}
      >
        <WhatsAppGlyph className="h-4 w-4" />
      </button>
    );
  }

  if (variant === "ghost") {
    return (
      <button
        onClick={onClick}
        className={cn(
          "inline-flex items-center gap-1.5 text-xs font-bold text-muted-foreground hover:text-foreground tap",
          className,
        )}
      >
        <Share2 className="h-3.5 w-3.5" />
        {label ?? "Teilen"}
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-md bg-[#25D366] text-white font-bold px-4 py-3 tap shadow-pop hover:opacity-90 transition w-full",
        className,
      )}
    >
      <WhatsAppGlyph className="h-5 w-5" />
      <span>{label ?? "Per WhatsApp einladen"}</span>
    </button>
  );
}

function WhatsAppGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M20.52 3.48A11.93 11.93 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.84c0 2.09.55 4.12 1.6 5.92L0 24l6.4-1.68a11.85 11.85 0 0 0 5.64 1.43h.01c6.54 0 11.84-5.3 11.84-11.84 0-3.16-1.23-6.13-3.37-8.43ZM12.05 21.3h-.01a9.45 9.45 0 0 1-4.81-1.32l-.34-.2-3.8 1 1.02-3.7-.22-.38a9.46 9.46 0 0 1-1.45-5.04c0-5.23 4.26-9.49 9.5-9.49 2.54 0 4.92.99 6.71 2.78a9.42 9.42 0 0 1 2.78 6.71c0 5.24-4.26 9.49-9.5 9.49Zm5.2-7.1c-.28-.14-1.68-.83-1.94-.93-.26-.1-.45-.14-.64.14-.19.28-.74.93-.9 1.12-.17.19-.33.21-.61.07-.28-.14-1.2-.44-2.27-1.4-.84-.75-1.4-1.67-1.57-1.95-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.5.14-.17.19-.28.28-.47.09-.19.05-.35-.02-.5-.07-.14-.64-1.55-.88-2.12-.23-.55-.46-.48-.64-.49l-.55-.01c-.19 0-.5.07-.76.35-.26.28-1 .98-1 2.4 0 1.4 1.02 2.76 1.16 2.95.14.19 2 3.06 4.84 4.29.68.29 1.21.46 1.62.59.68.22 1.3.18 1.79.11.55-.08 1.68-.69 1.92-1.35.24-.66.24-1.23.17-1.35-.07-.12-.26-.19-.54-.33Z"/>
    </svg>
  );
}
